import { render, staticRenderFns } from "./SecurityCenter.vue?vue&type=template&id=633768b1&scoped=true"
import script from "./SecurityCenter.vue?vue&type=script&lang=js"
export * from "./SecurityCenter.vue?vue&type=script&lang=js"
import style0 from "./SecurityCenter.vue?vue&type=style&index=0&id=633768b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633768b1",
  null
  
)

export default component.exports